import React from 'react';
import GroupedFaqList from '../components/GroupedFaqList';

const groupedFaqItems = [
  {
    title: "① 계약 전 체크리스트",
    items: [
      {
        question: "임대차 계약 전에 확인해야 할 문서는 어떤 것이 있나요?",
        answer: "등기부등본, 건축물대장, 중개사 등록증, 실거래가 정보, 건물의 전세가율 등을 확인해야 합니다."
      },
      {
        question: "건축물대장에서 어떤 내용을 확인해야 하나요?",
        answer: "건물 용도(주거용인지), 위반 건축물 여부, 사용승인일 등을 확인하면 불법 건물 가능성을 파악할 수 있습니다."
      },
      {
        question: "공인중개사가 등록된 곳인지 확인하는 방법은?",
        answer: "국토교통부 중개사무소 조회 서비스에서 사업자등록번호로 조회 가능합니다"
      },
      {
        question: "임대인이 소유자가 아닐 수도 있나요?",
        answer: "전대차일 수 있습니다. 반드시 등기부등본 상 '소유자'와 계약 상대방이 동일한지 확인하세요."
      },
      {
        question: "보증금이 시세보다 유독 저렴한데 괜찮을까요?",
        answer: "깡통전세일 수 있습니다. 시세보다 과도하게 낮은 전세는 매우 주의가 필요합니다."
      },
      {
        question: "중개사가 계약을 너무 재촉해요. 이상한가요?",
        answer: "계약을 서두르게 만들거나 불안감을 유도하는 경우 사기일 수 있습니다. 신중하게 판단하세요."
      },
      {
        question: "임대차 계약 전에 AI 분석을 받을 수 있나요?",
        answer: "전세가드 AI에 계약서를 업로드하면 주요 항목과 특약사항 위험을 사전에 분석할 수 있습니다."
      },
    ]
  },
  {
    title: "② 계약 체결 시 유의사항",
    items: [
      {
        question: "임대인이 여러 명일 때 계약은 어떻게 하나요?",
        answer: "공동소유일 경우 모든 소유자의 서명이 필요합니다. 한 명과만 계약하면 무효가 될 수 있어요."
      },
      {
        question: "임대인이 법인일 경우 주의할 점이 있나요?",
        answer: "법인 임대인은 파산 시 보증금 회수에 어려움이 큽니다. 법인 등기사항증명서 확인이 필요합니다."
      },
      {
        question: "계약서에 꼭 들어가야 하는 핵심 항목은?",
        answer: "계약일, 주소, 임대인·임차인 인적사항, 보증금, 월세, 계약기간, 특약사항, 중개사 서명 등이 필수입니다."
      },
      {
        question: "임대인의 인감도장이 없어도 계약 가능한가요?",
        answer: "원칙적으로 서명만으로도 유효하지만, 명의도용 예방을 위해 인감날인과 인감증명서를 함께 요구하는 것이 좋습니다."
      },
      {
        question: "계약서 특약사항은 어떻게 점검하나요?",
        answer: "전세가드 AI는 특약 문구를 분석하여 위험 여부를 분류해줍니다. 계약 전 반드시 분석받는 것이 좋습니다."
      },
    ]
  },
  {
    title: "③ 계약 직후 해야 할 일",
    items: [
      {
        question: "확정일자랑 전입신고는 어떻게 다른가요?",
        answer: "확정일자는 법원 도장, 전입신고는 주민센터 등록입니다. 둘 다 받아야 임차인 보호됩니다."
      },
      {
        question: "계약 후 바로 전입신고해도 괜찮나요?",
        answer: "잔금과 입주일 이후 동시에 해야 보증금 우선변제권이 생깁니다."
      },
      {
        question: "확정일자와 전입신고는 어디서 하나요?",
        answer: "확정일자는 동 주민센터 또는 인터넷등기소에서, 전입신고는 주민센터에서 합니다."
      }
    ]
  },
  {
    title: "④ 특약 사항에서 주의할 문구",
    items: [
      {
        question: "특약사항에 이런 문구가 있는데 위험한가요?",
        answer: "'전입신고 금지', '보증금 반환은 임대인 사정에 따라' 등은 전세사기에서 자주 쓰이는 수법입니다."
      },
      {
        question: "위험한 특약은 무조건 삭제해야 하나요?",
        answer: "삭제 또는 문구 수정 요청이 필요하며, 거절할 경우 계약 진행을 재검토하는 것이 좋습니다."
      }
    ]
  },
  {
    title: "⑤ 임차인 보호 조치",
    items: [
      {
        question: "확정일자와 전입신고는 반드시 둘 다 해야 하나요?",
        answer: "네. 둘 다 해야 '대항력'과 '우선변제권'이 생깁니다."
      },
      {
        question: "계약 전에 등기부등본을 꼭 봐야 하나요?",
        answer: "필수입니다. 근저당권, 가압류, 소유권 변경 이력은 사기 여부를 판단하는 핵심 요소입니다."
      },
      {
        question: "잔금 치르기 전에 어떤 절차를 거쳐야 안전할까요?",
        answer: "잔금 전날 등기부등본을 재확인하고 권리변동 여부를 반드시 체크하세요."
      },
      {
        question: "보증보험에 가입하면 정말 안전한가요?",
        answer: "가입 시 보증금 반환을 보장받을 수 있습니다. 단, 가입 조건과 보장 한도를 반드시 확인하세요."
      }
    ]
  },
  {
    title: "⑥ JeonseGuard AI 활용법",
    items: [
      {
        question: "AI 분석은 어떤 부분까지 해주나요?",
        answer: "AI는 계약서의 주요 항목을 추출하고, 위험 여부를 자동으로 분류해드립니다."
      },
      {
        question: "OCR로 텍스트 추출이 잘 안 되는 경우는?",
        answer: "이미지 해상도가 낮거나 문서 양식이 매우 특이한 경우입니다. 이 경우에는 스캔본을 다시 업로드해주세요."
      },
      {
        question: "실거래가 정보도 함께 제공되나요?",
        answer: "네. AI 분석 외에도 실거래가 데이터를 기반으로 시세 비교가 가능합니다."
      }
    ]
  }
];

function FaqPage() {
  return (
    <div className="main-page-container">
      <GroupedFaqList groupedFaqItems={groupedFaqItems} />
    </div>
  );
}

export default FaqPage;
